import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

export const setup = (dashboardType, query) => ({
  type: types.SETUP,
  dashboardType,
  query,
});

export const done = () => ({
  type: types.DONE,
})
